var React = require('react');

function RightArrowDesktopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-0.998047 16.9978H30.9974M30.9974 16.9978L14.9997 1.00007M30.9974 16.9978L14.9997 32.9955","stroke":"#414141","strokeWidth":"0.901931"}));
}

RightArrowDesktopInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = RightArrowDesktopInline;

RightArrowDesktopInline.default = RightArrowDesktopInline;
